/**
 * @owner @Appboy/push
 */

// generated from 52_180 samples

import { z } from "zod";
import { common } from "../common";
import { clickActionSchema } from "../shared/clickActionSchema";
import { webPushUriTypeSchema } from "../shared/webPushUriTypeSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const webPushMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("webPush"),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 24_681 (50.04%)
  image_url: z.string().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // true 15_853 (32.14%), false 33_474 (67.86%)
  is_custom_image_url: z.boolean().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // true 278 (0.56%), false 49_049 (99.44%)
  is_custom_large_image_url: z.boolean().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 43_548 (88.28%)
  large_image_url: z.string().nullable().optional(),
  // avg: 277555722.97, min: 0, max: 1749517220
  last_sent_web_push: z.int().min(0),
  optimal_send_percentage: z.int().min(0).max(100).nullable(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // true 6_735 (13.65%), false 42_592 (86.35%)
  require_interaction: z.boolean().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 7_433 (15.07%)
  web_custom_uri: z.string().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 49_102 (99.54%)
  web_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // true 2_164 (4.39%), false 47_163 (95.61%)
  web_only_most_recent_device: z.boolean().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  web_push_buttons: z
    .array(
      z.object({
        // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
        action_type: clickActionSchema,
        human_readable: z.string(),
        id: common.objectId,
        // true 41 (1.24%), false 3_260 (98.76%)
        marked_as_deleted: z.boolean(),
        // null: 15 (0.45%)
        text: z.string().nullable(),
        // null: 406 (12.30%)
        uri: z.string().nullable(),
        use_webview: z.boolean().nullable(),
      })
    )
    .optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 5 (0.01%)
  web_push_message: z.string().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 402 (0.81%)
  // avg: 2161015.25, min: 0, max: 2419200
  web_time_to_live: z.int().min(0).nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 4 (0.01%)
  web_title: z.string().nullable().optional(),
  // undefined: 2_853 (5.47%), defined 49_327 (94.53%)
  // null: 23 (0.05%)
  web_uri_type: webPushUriTypeSchema.nullable().optional(),
});
